import { QualityWidgetType } from '../models/';
import { QualityPercentageEvolutionWidget } from './percentageEvolution/qualityPercentageEvolution/qualityPercentageEvolution.widget';

export function createQualityPercentageEvolutionWidget(type: string, config?: any): QualityPercentageEvolutionWidget {
    let localConfig: {
        name: string,
        qualityWidgetType: QualityWidgetType
    };
    switch (type) {
        case 'percentageOfBadValuesEvolution':
            localConfig = {
                name: 'Trend of percentage of bad tags',
                qualityWidgetType: QualityWidgetType.PercentageOfBadValuesTrend
            };
            break;
        case 'percentageOfFlatEvolution':
            localConfig = {
                name: 'Trend of the percentage of flat tags',
                qualityWidgetType: QualityWidgetType.PercentageOfFlatTrend
            };
            break;
        case 'percentageOfInvalidKPIsEvolution':
            localConfig = {
                name: 'Trend of the percentage of invalid KPIs',
                qualityWidgetType: QualityWidgetType.PercentageOfInvalidKPITrend
            };
            break;
        case 'percentageOfMissingEvolution':
            localConfig = {
                name: 'Percentage of missing values evolution',
                qualityWidgetType: QualityWidgetType.PercentageOfMissingTrend
            };
            break;
        case 'percentageOfOutOfRangeEvolution':
            localConfig = {
                name: 'Trend of the percentage of out-of-range tags',
                qualityWidgetType: QualityWidgetType.PercentageOfOutOfRangeTrend
            };
            break;
        case 'percentageOfScatterEvolution':
            localConfig = {
                name: 'Trend of percentage of scattered tags',
                qualityWidgetType: QualityWidgetType.PercentageOfScatterTrend
            };
            break;
        case 'percentageOfSuspiciousKPIsEvolution':
            localConfig = {
                name: 'Trend of the percentage of suspicious KPIs',
                qualityWidgetType: QualityWidgetType.PercentageOfSuspiciousKPITrend
            };
            break;
        case 'qualityPercentageEvolution':
            localConfig = {
                name: config?.name,
                qualityWidgetType: config?.qualityWidgetType
            };
            break;
    }
    const widget = !!localConfig
        ? new QualityPercentageEvolutionWidget((Object as any).assign({}, localConfig, config)) // order of copy is important to override defualt parameters
        : null;
    return widget;
}